// Voorlees-player: speelt de gegenereerde MP3 af met een voortgangsbalk waarmee
// je kunt scrubben, plus 10 seconden vooruit/terug. Geregistreerd als Alpine.data('ttsPlayer').
export default function registerTtsPlayer(Alpine) {
    Alpine.data('ttsPlayer', () => ({
        open: false,
        playing: false,
        currentTime: 0,
        duration: 0,

        // Percentage voor de gevulde balk.
        get progress() {
            return this.duration ? (this.currentTime / this.duration) * 100 : 0;
        },

        // Vanuit de menubalk: player openen en direct beginnen met voorlezen.
        openAndPlay() {
            this.open = true;
            this.$refs.audio.play();
        },

        close() {
            this.$refs.audio.pause();
            this.open = false;
        },

        toggle() {
            const audio = this.$refs.audio;
            audio.paused ? audio.play() : audio.pause();
        },

        seek(value) {
            this.$refs.audio.currentTime = Number(value);
        },

        skip(seconds) {
            const audio = this.$refs.audio;
            audio.currentTime = Math.min(Math.max(audio.currentTime + seconds, 0), this.duration || 0);
        },

        formatTime(seconds) {
            const total = Math.max(0, Math.floor(seconds || 0));
            const minutes = Math.floor(total / 60);
            const secs = String(total % 60).padStart(2, '0');
            return `${minutes}:${secs}`;
        },
    }));
}
